import gql from 'graphql-tag';

export const GET_PARTNER_LINK = gql`
  query GetPartnerLink($id: ID) {
    partnerLink(id: $id) {
      partnerLinkId
      dynamicsPartnerAccountId
      name
      logo
    }
  }
`;
